module.exports = __webpack_public_path__ + "img/nine.ef493955.jpg";